module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0123.jpg?v=43e9f1a2";